import React, { Component } from 'react'
import './ThankYouPage.css';
import numeral from 'numeral';
import CheckCircleIcon from '../../Global_Layouts/CheckCircleIcon/CheckCircleIcon'
import { openNewBrowserTab } from '../../Helpers/OpenNewBrowserTab';
import { getURLParams } from '../../Helpers/getURLParams';
import { deleteURLParams } from '../../Helpers/deleteURLParams';
import { SHIPPING_OPTIONS } from '../../Layouts/Layouts_PurchaseForm/ShippingTypeSelector/ShippingTypeSelector';

export default class ThankYouPage extends Component {

  state = {
    discount_code: null,
    discount_value: this.props.discount_value || 0,
  }

  componentDidMount=()=>{
    const modalContainer = document.querySelector('.pure-modal .panel-body');
    modalContainer.scrollTop = 0;
    let params_values = getURLParams(["discount_code", "discount_value"])
    if(parseInt(params_values.discount_value)>0){
      this.setState({
        discount_code: params_values.discount_code,
        discount_value: parseInt(params_values.discount_value)
      })
    }
    deleteURLParams(["discount_code", "discount_value"])
  }

  reqHelpWithOrder=()=>{
    const {thankYouPageData, first_name} = this.props
    openNewBrowserTab(`https://api.whatsapp.com/send?phone=573197873796&text=Hola%20soy%20${first_name}%20y%20quiero%20actualizar%20algo%20mi%20pedido%20%238${thankYouPageData.order_data.order_number.toString()}`)
  }

  // getOrderNumber = () => {
  //   const { thankYouPageData } = this.props;
  //   const originalOrderNumber = thankYouPageData.order_data.order_number;
  //   if (thankYouPageData.order_data.isFKOrder) {
  //     const base = parseInt(originalOrderNumber, 10);
  //     const today = new Date();
  //     const day = today.getDate();
  //     const month = today.getMonth() + 1; // Months are zero-based
  //     const year = today.getFullYear() % 100; // Only last two digits
  //     const fkOrderNumber = base + (day*month) + month + year;
  //     return fkOrderNumber;
  //   } else {
  //     return originalOrderNumber
  //   }
  // }

  getOrderNumber = () => {
    const { thankYouPageData } = this.props;
    const originalOrderNumber = thankYouPageData.order_data.order_number;
    if (thankYouPageData.order_data.isFKOrder) {
      const base = parseInt(originalOrderNumber, 10);
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;         // Mes (1–12)
      const year = today.getFullYear() % 100;     // Últimos dos dígitos del año
      const hour = today.getHours();              // Hora en formato 24 h (0–23)
      const fkOrderNumber = base + (day * (hour + 1)) + month + year;
      return fkOrderNumber;
    } else {
      return originalOrderNumber;
    }
  }

  render() {
    const { shipping_type_code, free_shipping, shipping_cost, thankYouPageData, ProductData, selectedPackData, quantity, first_name, last_name,  phone_number, address1, address2, province, city, contact_email, note } = this.props
    const { discount_code, discount_value } = this.state

    const order_number = this.getOrderNumber();

    const def_shipping_cost = shipping_type_code === "Normal" ? shipping_cost : SHIPPING_OPTIONS?.find(option => option.code === shipping_type_code)?.price || 0;

    return (
      <div className='ThankYouPage'>
        <CheckCircleIcon/>
        <div className='ThankYouPage_header'>
          <div className='ThankYouPage_title'>¡Gracias {first_name}!</div>
          {/* <div className='ThankYouPage_text'>Hemos recibido tu pedido #8{thankYouPageData.order_data.order_number} con exito</div> */}
          <div className='ThankYouPage_text'>Hemos recibido tu pedido #8{order_number} con exito</div>
        </div> 

        <div className='ThankYouPage_order_summary'>
          <div>Resumen de tu pedido</div>
          {thankYouPageData.order_data.line_items.map(item=>
            <ThankYouPage_order_summary_product_box item={item} selectedPackData={selectedPackData} ProductData={ProductData} order_data={thankYouPageData.order_data}/>
          )}

          {discount_value!==undefined && discount_value!==null && discount_value!==""?
            <div className='ThankYouPage_order_summary_total'>
              <div className='ThankYouPage_order_summary_total_label'>Descuentos</div>
              <div className='ThankYouPage_order_summary_total_value'>- { numeral(discount_value).format('$ 0,0[.]00') }</div>
            </div>
          :null}

          {free_shipping!==true || shipping_type_code !== "Normal" ?
            <div className='ThankYouPage_order_summary_total'>
              <div className='ThankYouPage_order_summary_total_label'>Envío</div>
              {/* <div className='ThankYouPage_order_summary_total_value'>- { numeral(shipping_cost).format('$ 0,0[.]00') }</div> */}
              <div className='ThankYouPage_order_summary_total_value'>+ { numeral(def_shipping_cost).format('$ 0,0[.]00') }</div>
            </div>
          :null}
          
          <div className='ThankYouPage_order_summary_total'>
            <div className='ThankYouPage_order_summary_total_label'>Total a pagar contra entrega</div>
            {/* <div className='ThankYouPage_order_summary_total_value'>{ numeral(thankYouPageData.order_data.total_price - discount_value + (free_shipping? 0 : shipping_cost)).format('$ 0,0[.]00') }</div> */}
            <div className='ThankYouPage_order_summary_total_value'>{ numeral(thankYouPageData.order_data.total_price - discount_value + (def_shipping_cost)).format('$ 0,0[.]00') }</div>
          </div>
        </div>

        <div className='ThankYouPage_shipping_data'>
          <div className='ThankYouPage_shipping_data_header'>Datos para la entrega</div>
          <ThankYouPage_shipping_data_field field={first_name +" "+ last_name}/>
          <ThankYouPage_shipping_data_field field={phone_number}/>
          <ThankYouPage_shipping_data_field field={address1}/>
          <ThankYouPage_shipping_data_field field={address2}/>
          <ThankYouPage_shipping_data_field field={city + "/" + province}/>
          <ThankYouPage_shipping_data_field field={contact_email}/>
        </div>

        <div className='ThankYouPage_footer'>
          <div className='ThankYouPage_footer_text'>Recuerda tener el dinero listo para el momento de la entrega</div>
          <div onClick={this.reqHelpWithOrder} className='ThankYouPage_footer_btn_primary'>¿Necesitas modificar algo de tu pedido?</div>
        </div>
      </div>

    )
  }
}

class ThankYouPage_order_summary_product_box extends Component {
  render() {
    const {selectedPackData, ProductData, order_data, item} = this.props
    return (
    <div className='ThankYouPage_order_summary_product_box'>
      <img className='ThankYouPage_order_summary_img' src={ item.sku_img } alt="" />
      <div className='ThankYouPage_order_summary_product_data'>
        <div className='ThankYouPage_order_summary_product_data_title'>{ item.title }</div>
        <div className='ThankYouPage_order_summary_product_data_subtitle'>{ item.variant_title }</div>
        <div className='ThankYouPage_order_summary_product_data_qty'>{ item.quantity } x <span className='ThankYouPage_order_summary_product_data_price'>{ numeral(item.price).format('$ 0,0[.]00') }</span></div>
      </div>
    </div>
    )
  }
}

class ThankYouPage_shipping_data_field extends Component {
  render() {
    const {field} = this.props
    return (
      <div className='ThankYouPage_shipping_data_field'>- {field}</div>
    )
  }
}


